module.exports = __webpack_public_path__ + "static/media/group.133cfcdf.png";